"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelCropParameterState = exports.CollectionModelCropParameterStateMutator = void 0;
const id_1 = require("../../../id");
const free_cropParameter_1 = require("./free.cropParameter");
function makeCropParameterState(tag, id) {
    switch (tag) {
        case 'free':
            return free_cropParameter_1.CollectionModelFreeCropParameter.state(id);
        default:
            throw new Error(`Unknown marker type: "${tag}"`);
    }
}
class CollectionModelCropParameterStateMutator {
    constructor(state) {
        this.state = state;
    }
    getState() {
        const collectionState = this.state.collection.state;
        const captureCropParameterKey = CollectionModelCropParameterState.captureCropParameterId(this.state.captureId);
        const state = collectionState.getFieldValue(captureCropParameterKey);
        if (state == null) {
            return [];
        }
        return state.slice();
    }
    setState(state) {
        const collectionState = this.state.collection.state;
        const captureCropParameterKey = CollectionModelCropParameterState.captureCropParameterId(this.state.captureId);
        collectionState.setFieldValue(captureCropParameterKey, state);
    }
    create(tag, id = id_1.IkeId.generate()) {
        const state = makeCropParameterState(tag, id);
        return this.createWithState(state);
    }
    remove(cropParameter) {
        const cropParameterIds = this.getState();
        const index = cropParameterIds.indexOf(cropParameter.id);
        if (index === -1) {
            throw new Error(`Cannot remove crop correction. Instance "${cropParameter.id}" is missing from capture "${this.state.captureId}"`);
        }
        cropParameterIds.splice(index, 1);
        this.setState(cropParameterIds);
        delete this.state.cropParameters[cropParameter.id];
        cropParameter.Mutator.destroyState();
    }
    clear() {
        const cropParameters = this.state.values();
        for (const cropParameter of cropParameters) {
            const cropParameterIds = this.getState();
            const index = cropParameterIds.indexOf(cropParameter.id);
            if (index === -1) {
                continue;
            }
            this.remove(cropParameter);
        }
    }
    createWithState(state) {
        const collectionState = this.state.collection.state;
        const captureId = this.state.captureId;
        const stateId = CollectionModelCropParameterState.cropParameterId(captureId, state.id);
        if (collectionState.fields.get(stateId) != null) {
            throw new Error(`Crop Correction "${stateId}" already exists`);
        }
        collectionState.setFieldValue(stateId, state);
        const cropParameterState = this.getState();
        cropParameterState.push(state.id);
        this.setState(cropParameterState);
        return state.id;
    }
}
exports.CollectionModelCropParameterStateMutator = CollectionModelCropParameterStateMutator;
const ID_PREFIX_CROP_CORRECTION = 'c';
const ID_PREFIX_CAPTURE_CROP_CORRECTION = 'cl';
class CollectionModelCropParameterState {
    static cropParameterId(captureId, cropParameterId) {
        return `${ID_PREFIX_CROP_CORRECTION}:${captureId}:${cropParameterId}`;
    }
    static captureCropParameterId(captureId) {
        return `${ID_PREFIX_CAPTURE_CROP_CORRECTION}:${captureId}`;
    }
    static getCaptureCropParameterId(key) {
        if (key.startsWith(`${ID_PREFIX_CAPTURE_CROP_CORRECTION}:`)) {
            return key.substr(3);
        }
        return null;
    }
    constructor(collection, captureId) {
        this.Mutator = new CollectionModelCropParameterStateMutator(this);
        this.id = id_1.IkeId.generate();
        this.cropParameters = {};
        this.collection = collection;
        this.captureId = captureId;
    }
    useInExportCorrection(cropParameterId) {
        if (!this.hasCropParameter(cropParameterId)) {
            return false;
        }
        else {
            let brightness = this.getCropParameter(cropParameterId);
            switch (brightness.state.tag) {
                case 'free':
                    const free = this.getCropParameter(cropParameterId);
                    return free.width > 0 && free.height > 0;
                default:
                    return false;
            }
        }
    }
    hasCropParameter(cropParameterId) {
        return this.state.indexOf(cropParameterId) > -1;
    }
    getCropParameter(cropParameterId) {
        let cropParameter = this.cropParameters[cropParameterId];
        if (cropParameter == null) {
            let cropParameterState = this.collection.state.getFieldValue(CollectionModelCropParameterState.cropParameterId(this.captureId, cropParameterId)); //FIXME
            if (cropParameterState == null) {
                //if we can't find a state with the current id, we recreate a new state with the same id, and query it again
                this.Mutator.create('free', cropParameterId);
                cropParameterState = this.collection.state.getFieldValue(CollectionModelCropParameterState.cropParameterId(this.captureId, cropParameterId));
            }
            switch (cropParameterState.tag) {
                case 'free':
                    cropParameter = new free_cropParameter_1.CollectionModelFreeCropParameter(this, cropParameterId, this.captureId);
                    break;
                default:
                    throw new Error(`Capture ${this.captureId}:Unknown brightness correction type: "${cropParameterState.tag}"`);
            }
            this.cropParameters[cropParameterId] = cropParameter;
        }
        return cropParameter;
    }
    values() {
        const output = [];
        for (const cropParameterId of this.state) {
            const cropParameter = this.getCropParameter(cropParameterId);
            output.push(cropParameter);
        }
        return output;
    }
    useInExportCorrections() {
        let state = false;
        if (this.hasCropParameters()) {
            this.state.forEach((el) => {
                state = this.useInExportCorrection(el);
            });
        }
        return state;
    }
    hasCropParameters() {
        return this.state.length > 0;
    }
    get capture() {
        return this.collection.state.getCapture(this.captureId);
    }
    get state() {
        return (this.collection.state.getFieldValue(CollectionModelCropParameterState.captureCropParameterId(this.captureId)) || []);
    }
}
exports.CollectionModelCropParameterState = CollectionModelCropParameterState;
//# sourceMappingURL=cropParameter.state.js.map